import map from './parser-map';
import helpers from '../helpers';

const outcomeMap = map.match.bet.outcome;

class MatchBetOutcome {
  constructor(rawObj) {
    this.id = rawObj[outcomeMap.id];
    this.idMatchBet = rawObj[outcomeMap.idMatchBet];
    this.idMatchBetOutcome = rawObj[outcomeMap.idMatchBetOutcome];
    this.blocked = rawObj[outcomeMap.blocked];
    this.value = parseFloat(rawObj[outcomeMap.value]).toFixed(2);
    this.providerId = rawObj[outcomeMap.providerId];
    this.position = parseInt(rawObj[outcomeMap.position], 10) || helpers.maxInt;
    this.name = rawObj[outcomeMap.name];
    this.shortName = rawObj[outcomeMap.shortName] || this.name;
    this.shortcut = rawObj[outcomeMap.shortcut];
    this.change = null;
    this.convertOdd();
  }

  convertOdd() {
    this.display = {
      1: this.value,
      2: helpers.toLocaleOdd(parseFloat(this.value), 2, 2),
      3: helpers.toLocaleOdd(parseFloat(this.value), 3, 2),
    };
  }

  addOddIndicator(oldOddValue, newOddValue) {
    if (parseFloat(oldOddValue) < parseFloat(newOddValue)) {
      this.change = 'UP';
    } else
    if (parseFloat(oldOddValue) > parseFloat(newOddValue)) {
      this.change = 'DOWN';
    }

    this.timeout = setTimeout(() => {
      clearTimeout(this.timeout);
      this.resetOddIndicator();
    }, 5000);
  }

  resetOddIndicator() {
    this.change = null;
  }
}

export default MatchBetOutcome;
